import { useState, useEffect } from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import LiveLoveLegacy from './components/LiveLoveLegacy'
import About from './components/About'
import HowItWorks from './components/HowItWorks'
import Services from './components/Services'
import LegacyBooks from './components/LegacyBooks'
import Testimonials from './components/Testimonials'
import Contact from './components/Contact'
import Footer from './components/Footer'
import './App.css'

function App() {
  const [activeSection, setActiveSection] = useState<string>('home')

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]')
      let current = 'home'

      sections.forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top
        if (sectionTop <= 100) {
          current = section.getAttribute('id') || 'home'
        }
      })

      setActiveSection(current)

      const elements = document.querySelectorAll('.fade-in-up')
      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        const elementVisible = 150

        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('visible')
        }
      })
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="App">
      <a className="skip-link" href="#home">Skip to content</a>
      <Navbar activeSection={activeSection} />
      <main>
        <Hero />
        <LiveLoveLegacy />
        <About />
        <HowItWorks />
        <Services />
        <LegacyBooks />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default App
